module.exports = __webpack_public_path__ + "img/mainPicture.c9784025.jpg";